export default "__VITE_ASSET__BTdMZuNR__"